import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormTemplateTypeEnum } from '../../_common/enum/forms/formTemplateType.enum';
import { QuoteLevelEnum } from '../../_common/enum/quoteLevel.enum';
import { QuoteTypeEnum } from '../../_common/enum/quoteType.enum';
import { IQuoteProviderComparisonResults } from '../../_common/interface/quoteProviderComparison/iQuoteProviderComparisonResults.interface';
import { getMoneyFormat } from '../../_helpers/format.helper';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { retryHeight, sendHeightToParent } from '../../_helpers/iFrameSize.helper';
import { formatQuoteDescription } from '../../_helpers/lowQuote.format.helper';
import { formService } from '../../_services/form.service';
import { useBoxStyles } from '../../_styles/box.styles';
import '../../_styles/lowQuote.css';


export function QuoteSection(params: {
    quote?: IQuoteProviderComparisonResults | null,
    healthApplicationData: any,
    title: string, cheapestRegularQuotePrice?: number | null,
    sx?: {},
    regularQuote?: number | null,
    isExpanded: boolean
}) {
    const [quoteDescription, setQuoteDescription] = useState<JSX.Element[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!params.quote || !params.quote.providerQuoteDescription) return;
        setQuoteDescription(formatQuoteDescription(params.quote.providerQuoteDescription, false, null));
    }, [params.quote]);

    function createNewFormForClient(formTemplateTypeId: FormTemplateTypeEnum, providerId: number, quoteType?: QuoteTypeEnum) {
        var _data = { formTemplateTypeId, quoteId: params.healthApplicationData.quoteId, clientId: params.healthApplicationData.clientId, providerId, quoteType, quoteLevel: params.title }
        return formService.createByTypeForClient(_data)
            .then(
                (id: number) => {
                    navigate(`/formOriginal/${id}/${_data.quoteId}`);

                    //    navigate(`/forms/${id}/${clientId}`);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (

        <>
            {params.quote &&

                <Box position="relative">
                    {/*<Box*/}
                    {/*    sx={{*/}
                    {/*        position: 'absolute',*/}
                    {/*        left: params.isExpanded ? '-20px' : { xs: '-15px', md: '-10px' },*/}
                    {/*        top: { xs: '25px', md: '50px' },*/}
                    {/*        transform: 'translateY(-50%)',*/}
                    {/*        width: { xs: params.isExpanded ? '45px' : '40px', md: params.isExpanded ? '65px' : '60px' },*/}
                    {/*        height: { xs: params.isExpanded ? '45px' : '40px', md: params.isExpanded ? '65px' : '60px' },*/}
                    {/*        backgroundColor: "secondary.main",*/}
                    {/*        borderRadius: '50%',*/}
                    {/*        display: 'flex',*/}
                    {/*        alignItems: 'center',*/}
                    {/*        justifyContent: 'center',*/}
                    {/*        zIndex: 1,*/}
                    {/*        transition: 'all 0.3s ease',*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <Typography*/}
                    {/*        color="#fff"*/}
                    {/*        fontSize={{ xs: "40px !important", md: "52px !important" }}*/}
                    {/*        marginTop="-6px"*/}
                    {/*    >&#43;</Typography>*/}
                    {/*</Box>*/}

                    <Box
                        sx={{
                            position: 'absolute',
                            left: params.isExpanded ? '-20px' : { xs: '-12px', md: '-10px' },
                            top: { xs: '20px', md: '50px' },

                            transform: params.isExpanded
                                ? 'translateY(-50%) scale(1.05)'
                                : 'translateY(-50%) scale(1)',

                            width: {
                                xs: params.isExpanded ? '36px' : '32px',
                                md: params.isExpanded ? '65px' : '60px',
                            },
                            height: {
                                xs: params.isExpanded ? '36px' : '32px',
                                md: params.isExpanded ? '65px' : '60px',
                            },

                            backgroundColor: 'secondary.main',
                            borderRadius: '50%',
                            display: 'grid',
                            placeItems: 'center',
                            zIndex: 1,

                            transition: 'transform 240ms cubic-bezier(0.2, 0, 0, 1), left 240ms cubic-bezier(0.2, 0, 0, 1), top 240ms cubic-bezier(0.2, 0, 0, 1)',
                            willChange: 'transform, left, top',
                            backfaceVisibility: 'hidden',
                        }}
                    >
                            <Typography
                                component="span"
                                sx={{
                                    color: '#fff',
                                    fontSize: { xs: '28px', md: '52px' },
                                    lineHeight: 1,
                                    display: 'block',
                                    m: 0,
                                    p: 0,
                                    transform: 'translateY(-1px)', // minus brings plus higher
                                }}
                            >
                                +
                            </Typography>
                        </Box>


                    <Card
                        sx={{
                            backgroundColor: 'primary.main',
                            transform: params.isExpanded ? 'scale(1.05)' : 'scale(1)',
                            transformOrigin: 'center',
                            transition: 'transform 240ms cubic-bezier(0.2, 0, 0, 1)',
                            willChange: 'transform',
                        }}
                    >
                        <CardContent>
                            <Box sx={useBoxStyles.cardHeaderBox}>
                                <Box sx={useBoxStyles.titleBox}

                                >
                                    <Typography variant="h4" textAlign="center" fontWeight="500">
                                        {params.title === QuoteLevelEnum.Bronze ? (params.quote.quoteType === QuoteTypeEnum.IncomeProtection || params.quote.quoteType === QuoteTypeEnum.ExecutiveIncomeProtection) ? "Protect CORE" : "Protect PLUS" :
                                            params.title === QuoteLevelEnum.Silver ? (params.quote.quoteType === QuoteTypeEnum.IncomeProtection || params.quote.quoteType === QuoteTypeEnum.ExecutiveIncomeProtection) ? "Protect ESSENTIAL" : "Protect PREMIUM" :
                                                params.title === QuoteLevelEnum.Gold ? "Protect ELITE" : ""}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box display="flex" flexDirection={{ xs: "column" }} justifyContent="center" alignItems="center" width="100%">


                                <Typography variant="subtitle1"
                                    fontWeight="500"
                                    textAlign="center"
                                    color={params.quote.providerQuote > 0 ? "#fff" : "#FAF9F6"} >

                                    {params.quote.providerQuote === 0 ? `Price not available` :
                                        (params.regularQuote && ((params.quote.providerQuote > params.regularQuote) || ((params.quote.quoteType === QuoteTypeEnum.IncomeProtection || params.quote.quoteType === QuoteTypeEnum.ExecutiveIncomeProtection) && params.title === QuoteLevelEnum.Gold))) ?
                                            "For an extra: " + getMoneyFormat((params.quote.quoteType === QuoteTypeEnum.IncomeProtection || params.quote.quoteType === QuoteTypeEnum.ExecutiveIncomeProtection) && params.title === QuoteLevelEnum.Gold ?
                                                ((params.quote.providerQuote + params.regularQuote) - params.regularQuote) : (params.quote.providerQuote - params.regularQuote)) :
                                            "Total: " + getMoneyFormat(params.quote.providerQuote)}

                                </Typography>
                                {params.quote.providerQuote > 0 &&
                                    <Typography variant="subtitle1"
                                        fontWeight="500"
                                        textAlign="center"
                                        color={params.quote.providerQuote > 0 ? "#fff" : "#FAF9F6"} >
                                        per month
                                    </Typography>
                                }

                                {!((params.quote.quoteType === QuoteTypeEnum.IncomeProtection || params.quote.quoteType === QuoteTypeEnum.ExecutiveIncomeProtection) && (params.title === QuoteLevelEnum.Bronze || params.title === QuoteLevelEnum.Silver)) &&
                                    <Typography variant="h4" fontWeight="bold" color="#fff" marginTop={2}>Upgrade to:</Typography>
                                }

                                <Typography
                                    variant="body1"
                                    color="#fff"
                                    sx={{ textAlign: "center" }}
                                >{quoteDescription}</Typography>
                                {(params.quote.quoteType === QuoteTypeEnum.IncomeProtection || params.quote.quoteType === QuoteTypeEnum.ExecutiveIncomeProtection) && (params.title === QuoteLevelEnum.Silver || params.title === QuoteLevelEnum.Bronze) &&
                                    <Typography
                                        variant="body1"
                                        marginTop="10px"
                                        color="#77c970"
                                        sx={{ textAlign: "center" }}
                                    >{params.title === QuoteLevelEnum.Silver ? "(75% of your chosen quote)" : "(50% of your chosen quote)"}</Typography>
                                }

                                {params.quote.isApplicable &&
                                    <Button variant="contained"
                                        color="secondary"
                                        onClick={() =>
                                            createNewFormForClient(
                                                FormTemplateTypeEnum.HealthQuestionnaire,
                                                params.quote!.providerId,
                                                params.quote!.quoteType,
                                            )
                                        }
                                        style={{ width: "100%", padding: "10px", marginTop: "8px" }}
                                    >
                                        <Typography fontWeight="bold">{params.quote.providerQuote > 0 ? "APPLY NOW" : "REQUEST A CALL BACK"}</Typography>
                                    </Button>
                                }
                            </Box>

                        </CardContent>
                    </Card>
                </Box>
            }
        </>
    );
};

